import styled from 'styled-components';

export const StyledItem = styled.div`
  cursor: pointer;
`;

